export const createActionTypes = type => ({
  PENDING: `${type.toUpperCase()}_PENDING`,
  SUCCESS: `${type.toUpperCase()}_SUCCESS`,
  FAILED: `${type.toUpperCase()}_FAILED`
});
